<template>
    <div class="upload-widget">
        <div v-for="(item, key) in lists" class="img-item" v-if="type == 'img'">
            <img :src="item.full_path" :data-id="key">
            <strong v-html="item.name" :title="item.name"></strong>
            <i class="icon icon-fangda" data-type="show" title="查看" @click="openWin(key)"></i>
            <i class="icon icon-baseline-close-px" data-type="remove" title="移除" @click="deleteItem(key)"></i>
            <input type="hidden" :name="name" :value="saveType == 'path' ? item.path: item.id">
        </div>

        <div class="custom-file" :class="'type-' + type" v-if="showUpload">
            <input type="file" class="custom-file-input" :multiple="isMultiple" :id="id"
                   @change="fileChange" :accept="type == 'img' ? 'image/*' : (type == 'video' ? 'video/*' : '*')"
                   lang="cn">

            <label :for="id">
                <slot name="text">
                    <label class="custom-file-label"><span>{{ textLabel }}</span></label>
                </slot>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: "FileUploader",
    computed: {
        showUpload() {
            return this.isMultiple ? true : !this.lists.length;
        },
        isMultiple() {
            return  this.name && this.name.indexOf('[]') > -1;
        },
        textLabel() {
            const typeLabel = {
                img: '选择图片',
                file: '选择文件',
                video: '选择视频',
            }

            return typeLabel[this.type] || ''
        }
    },
    model: {
        prop: 'paths',
        event: 'change',
    },
    props: {
        paths: {
            type: [Array, String]
        },
        name: {
            type: String,
        },
        type: {
            type: String,
            default: 'img'
        },
        saveType: {
            type: String,
            default: 'path'
        },
        disk: {
            type: String
        },
        defaultList: {
            type: Array,
        }
    },
    data() {
        return {
            id: 'customFile' + Math.random(),
            lists: [],
            exts: [],
        }
    },
    mounted() {
        this.lists = this.defaultList || [];
    },
    methods: {
        fileUpload(files) {
            const total = files.length;
            let uploadFileCount = 0;
            const doneArr = [];
            return new Promise((resolve, reject) => {
                if(!files.length) {
                    reject(new Error('files is empty'));
                }
                Array.prototype.forEach.call(files, (file => {

                    const formData = new FormData();
                    if (this.disk) {
                        formData.append("disk", this.disk); //加入文件对象
                    }
                    formData.append('file', file);
                    $.ajax({
                        url: "/upload",
                        data: formData,
                        type: "Post",
                        dataType: "json",
                        cache: false,//上传文件无需缓存
                        processData: false,//用于对data参数进行序列化处理 这里必须false
                        contentType: false, //必须
                        complete: () => {
                            uploadFileCount += 1;
                            if (uploadFileCount === total) {
                                resolve(doneArr);
                            }
                        },
                        success: (resp) => {
                            doneArr.push({
                                id: resp.id,
                                name: resp.name,
                                path: resp.path,
                                full_path: resp.full_path
                            });
                        },
                    });
                }));
            });
        },
        fileChange(e) {
            this.uploadFileCount = 0
            const fileLenght = e.currentTarget.files.length
            if (fileLenght) {
                layer.load()
            }
            this.fileUpload(e.currentTarget.files).then(ret => {
                this.callback(ret).then(r => {
                    this.lists = r;
                    this.emitFileChanged();
                })
            }).catch(err => {
                console.error(err);
                common.msg('error', err.message);
            }).finally(() => {
                layer.closeAll('loading');
            });
        },
        emitFileChanged() {
            this.$emit('change', !this.isMultiple ? (this.lists[0]? this.lists[0].path : null) : this.lists.map(rec => rec.path));
        },
        callback(rets) {
            const total = rets;
            let cur = 0;
            return new Promise((resolve, reject) => {
                if (this.type == 'video') {
                    const arr = [];
                    rets.forEach(res => {
                        if (typeof res.path !== 'undefined') {
                            //视频保存到视频信息表
                            $.post("{{ route('upload.save_video_info') }}", {
                                file_id: res.id
                            }, resp => {
                                arr.push(resp.data);
                                cur++;
                                if(cur === total) {
                                    resolve(arr);
                                }
                            });
                        } else {
                            common.msg('error', '上传文件错误')
                            reject(new Error('上传文件错误'));
                        }
                    });
                } else {
                    resolve(rets);
                }
            });

        },
        deleteItem(key) {
            var index = layer.confirm('确定删除 <span class="text-danger">' + this.lists[key].name + '</span> 吗？', () => {
                this.lists.splice(key, 1)
                this.emitFileChanged()
                layer.close(index)
            })
        },
        openWin: function(key) {
            if (this.type == 'img') {
                common.preview_img(this.lists[key].full_path);
            } else {
                var url = "/getfile?path="+ this.lists[key].path;
                window.open(url);
            }
        },
    }
}
</script>

<style scoped>

</style>
